<template>
  <!-- 用户管理页面根容器 -->
  <div>
    <!-- 页面标题 -->
    <h3 style="margin-bottom:20px">用户管理</h3>

    <!--
      搜索输入框
      v-model 双向绑定搜索关键词
      用于模糊查询用户名
    -->
    <el-input
      v-model="searchKey"
      placeholder="输入用户名搜索"
      style="width:250px;margin-bottom:15px"
    />

    <!--
      用户数据表格
      :data 绑定表格数据
      border 显示边框
      @row-dblclick 双击行查看详情
    -->
    <el-table
      :data="showList"
      border
      @row-dblclick="showUserDetail"
    >
      <!-- 用户ID列 -->
      <el-table-column prop="id" label="用户ID" />

      <!-- 用户名称列 -->
      <el-table-column prop="name" label="用户名" />

      <!--
        用户状态列
        根据 status 字段动态显示 正常/禁用 标签
      -->
      <el-table-column label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>

      <!--
        操作列
        动态切换 禁用/启用 按钮
      -->
      <el-table-column label="操作">
        <template #default="scope">
          <el-button
            :type="scope.row.status===1?'danger':'success'"
            size="mini"
            @click="changeStatus(scope.row)"
          >
            {{ scope.row.status===1 ? '禁用' : '启用' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--
      分页组件
      控制表格数据分页显示
    -->
    <el-pagination
      style="margin-top:15px;text-align:right"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!--
      用户详情弹窗
      双击表格行打开
    -->
    <el-dialog
      title="用户详情"
      :visible.sync="detailVisible"
      :close-on-click-modal="false"
    >
      <!-- 详情表单，设置为禁用状态，仅用于查看 -->
      <el-form :model="currentUser" label-width="80px" disabled>
        <el-form-item label="用户ID">
          <span>{{ currentUser.id }}</span>
        </el-form-item>

        <el-form-item label="用户名">
          <span>{{ currentUser.name }}</span>
        </el-form-item>

        <el-form-item label="状态">
          <el-tag :type="currentUser.status === 1 ? 'success' : 'danger'">
            {{ currentUser.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 页面响应式数据定义
  data() {
    return {
      searchKey: '',        // 搜索关键词
      userList: [],         // 原始用户列表
      currentPage: 1,       // 当前页码
      pageSize: 5,          // 每页显示条数
      total: 0,             // 总记录数
      detailVisible: false, // 控制详情弹窗显示/隐藏
      currentUser: {}       // 当前查看的用户对象
    }
  },

  // 计算属性：根据搜索关键词过滤数据
  computed: {
    showList() {
      // 无搜索内容时，返回全部数据
      if (!this.searchKey) {
        return this.userList
      }
      // 有搜索内容时，模糊匹配用户名
      return this.userList.filter(item =>
        item.name.includes(this.searchKey)
      )
    }
  },

  // 页面挂载完成后自动获取用户列表
  async mounted() {
    this.getUserList()
  },

  // 页面方法集合
  methods: {
    // 获取用户列表数据
    async getUserList() {
      const { data } = await this.$axios.get('/api/user/list')
      this.userList = data.data
      this.total = data.data.length
    },

    // 修改用户状态（禁用/启用）
    changeStatus(row) {
      // 弹出确认提示框
      this.$confirm(
        `确定要${row.status === 1 ? '禁用' : '启用'}该用户吗？`,
        "提示",
        { closeOnClickModal: false }
      ).then(() => {
        // 切换状态：1 <-> 0
        row.status = row.status === 1 ? 0 : 1
        this.$message.success('状态修改成功')
      }).catch(() => {
        // 取消操作，不执行逻辑
      })
    },

    // 显示用户详情弹窗
    showUserDetail(row) {
      // 将当前行数据赋值给详情对象
      this.currentUser = row
      this.detailVisible = true
    }
  }
}
</script>